import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter  } from 'react-router-dom';
import Modal from 'react-modal';

import App from './App';
import registerServiceWorker from './registerServiceWorker';

Modal.setAppElement('#root');

const AppWithRouter = () => (
    <BrowserRouter>
        <App/>
    </BrowserRouter>
)

ReactDOM.render(<AppWithRouter />, document.getElementById('root'))
registerServiceWorker()


// WEBPACK FOOTER //
// ./src/index.js